import React from 'react';
import { cn } from './cn';

/**
 * Selectable filter chip. `toggle` renders a small switch indicator (used for "Show sold").
 */
const Chip = ({
  active = false,
  toggle = false,
  count,
  icon: Icon,
  onClick,
  className,
  children,
  ...rest
}) => (
  <button
    type="button"
    aria-pressed={active}
    onClick={onClick}
    className={cn(
      'inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full text-sm font-medium whitespace-nowrap select-none transition-colors duration-150 border',
      'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/60',
      active
        ? 'bg-accent text-[#062A24] border-accent'
        : 'bg-card text-secondary border-line hover:text-primary hover:border-line-strong',
      className
    )}
    {...rest}
  >
    {Icon && <Icon className="w-4 h-4" />}
    <span>{children}</span>
    {typeof count === 'number' && (
      <span
        className={cn(
          'text-xs tabular',
          active ? 'text-[#062A24]/80' : 'text-muted'
        )}
      >
        ({count})
      </span>
    )}
    {toggle && (
      <span
        aria-hidden="true"
        className={cn(
          'ml-1 relative inline-block w-7 h-4 rounded-full transition-colors duration-150',
          active ? 'bg-[#062A24]/35' : 'bg-line-strong'
        )}
      >
        <span
          className={cn(
            'absolute top-0.5 w-3 h-3 rounded-full bg-white transition-transform duration-150',
            active ? 'translate-x-3.5' : 'translate-x-0.5'
          )}
        />
      </span>
    )}
  </button>
);

/** Horizontally scrolling chip row that hides its scrollbar on mobile. */
export const ChipRow = ({ className, children }) => (
  <div
    className={cn(
      'flex items-center gap-2 overflow-x-auto scrollbar-hide -mx-4 px-4 lg:mx-0 lg:px-0 lg:flex-wrap',
      className
    )}
  >
    {children}
  </div>
);

export default Chip;
